import CRUDFactory from '@/services/CRUDFactory';

export default CRUDFactory('/typical-contract-headers');
